<template>
  <tr class="relative text-sm font-semibold">
    <!-- NOME -->
    <td>
      <div class="row relative overflow-hidden font-bold text-gray-50">
        <img
          :src="`/img/${data.bo_symbol.toLowerCase()}.jpg`"
          class="absolute top-1/2 left-0 w-full -translate-y-1/2 transform object-cover opacity-50"
        />
        <div
          class="to-ontick-graphite-500 absolute inset-0 bg-gradient-to-r from-transparent"
        ></div>
        <div class="relative z-10 flex flex-col">
          <span class="text-shadow text-base font-bold text-gray-50">
            {{ data.label }}
          </span>
          <span class="text-xs font-semibold text-gray-300 drop-shadow-md">
            ID: {{ data.bo_id }}
          </span>
          <span class="text-xs font-semibold text-gray-50">
            {{ data.bo_symbol }}
          </span>
        </div>
      </div>
    </td>

    <!-- ENTRADA -->
    <td>
      <div class="row">
        <div class="flex flex-col gap-1">
          <span v-if="!data.bo_entry_price"> - </span>
          <span v-else>
            {{
              data.bo_entry_price.toFixed(
                getSymbolData.find((item) => item.symbol == data.bo_symbol)
                  .decimal_places
              )
            }}
          </span>

          <span
            class="text-xs font-normal text-gray-400"
            v-if="data.bo_status == 'ACTIVE'"
          >
            {{ moment(data.bo_create_datetime).format("DD/MM/YYYY HH:mm:ss") }}
          </span>
          <span class="text-xs font-normal text-gray-400" v-else>
            Aguardando entrada
          </span>
        </div>
      </div>
    </td>

    <!-- BEST -->
    <td>
      <div class="row gap-2">
        <div class="flex flex-col gap-2">
          <div
            class="flex items-center rounded-full pr-2 text-gray-50"
            :class="
              data.bo_direction == 'BUY'
                ? 'bg-ontick-green-600'
                : 'bg-ontick-orange-600'
            "
          >
            <i v-if="data.bo_direction == 'BUY'" v-html="$icons.trend_up"></i>
            <i
              v-else-if="data.bo_direction == 'SELL'"
              v-html="$icons.trend_down"
            ></i>
            <span class="direction-shadow text-[10px] uppercase">
              {{ data.bo_direction == "BUY" ? "Sobe" : "Desce" }}
            </span>
          </div>
          <span class="text-xs font-normal text-gray-400">
            {{ data.bo_target }}{{ targetType }}
          </span>
        </div>
      </div>
    </td>

    <!-- MULTIPLICADOR -->
    <td>
      <div class="row flex items-center gap-2">
        <span> {{ data.bo_multiplier }}x </span>
      </div>
    </td>

    <!-- RESULTADO -->
    <td>
      <div class="row flex items-center gap-4">
        <span v-if="data.bo_status == 'NEW'"> Aguardando entrada </span>
        <div class="flex flex-col gap-2" v-else>
          <div class="flex items-center gap-2">
            <i
              v-html="icons.play_green"
              v-if="pnl(data).result > 0"
              class="h-3 w-3"
            ></i>
            <i
              v-html="icons.play_red"
              v-else-if="pnl(data).result < 0"
              class="h-3 w-3"
            ></i>
            <i v-else class="h-3 w-3 rounded-full bg-gray-500"></i>
            <span
              v-if="
                typeof pnl(data).result == 'number' && pnl(data).result != NaN
              "
              class="w-[96px] overflow-visible whitespace-nowrap"
            >
              {{ pnl(data).result | currency }}
            </span>
            <span v-else> - </span>
          </div>
          <best-progress-bar-component
            :symbol="data.bo_symbol"
            :entry_price="data.bo_entry_price"
            :target="data.bo_target"
            :target_type="data.best_target_type"
            :direction="data.bo_direction"
          />
        </div>
      </div>
    </td>

    <!-- PARAR -->
    <td>
      <div class="row gap-4">
        <button
          @click="$event_bus.$emit('BEST_STOP', data)"
          class="transition-all hover:brightness-125"
        >
          <i v-html="$icons.best_stop"></i>
          <span class="sr-only"> Parar </span>
        </button>
      </div>
    </td>
    <best-mask-component
      v-if="data.mask"
      :pnl="data.mask.pnl"
      :bo_id="data.bo_id"
    />
  </tr>
</template>

<script>
import { mapGetters } from "vuex";
import { iconsSet as icons } from "../../../assets/icons/icons";
import symbol_images from "../symbol_images";
import pnlMixin from "../pnl";
import bestMaskComponent from "./best-mask.component.vue";
import BestProgressBarComponent from "./best-progress-bar.component.vue";
export default {
  components: { bestMaskComponent, BestProgressBarComponent },

  mixins: [pnlMixin, symbol_images],
  props: {
    data: {
      type: Object,
    },
  },

  data() {
    return {
      icons,
    };
  },

  computed: {
    ...mapGetters({
      getSymbolData: "bests/getSymbolData",
      getSymbolPrice: "marketdata/getSymbolPrice",
    }),
    targetType() {
      switch (this.data.best_target_type) {
        case "POINTS":
          return "p";
        case "PERCENT":
          return "%";
        default:
          return "";
      }
    },
    direction() {
      switch (this.data.bo_direction) {
        case "BUY":
          return "Sobe";
        case "SELL":
          return "Desce";
        default:
          return "-";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use "../styles/bests.scss";
</style>
